import { Injectable } from '@angular/core';
import { TelemetryStorage, TelemetryEvent } from '@cv-invision/cv.component-library.ux';

/**
 * This class is thinking on the future, to save in some storage the events
 * we can send them later
 */
@Injectable()
export class IntelligenceStorageWrapper implements TelemetryStorage {
	/**
	 * Add the event to the storage
	 */
	async add(event: TelemetryEvent): Promise<void> {
		// Next implementation is save the event if the user close the tab
	}
}
